(() => {
  if (document.documentElement.lang !== 'ar' || document.documentElement.dir !== 'rtl') return;
  const skip = 'script, style, noscript, template, textarea, input, select, option, code, pre, bdi, svg, math, [contenteditable], [dir="ltr"], [data-ar-bidi="off"]';
  const arabic = /[\u0600-\u06ff]/;
  const latin = /(?:\(|\[)?[+−-]?(?:[A-Za-z0-9$€£¥₿℃℉°][A-Za-z0-9$€£¥₿℃℉_+./:%°×−–=()\[\]#,@&-]*)(?:[ \u00a0]+(?:[×±/−–-][ \u00a0]*)?\(?[A-Za-z0-9$€£¥₿℃℉°][A-Za-z0-9$€£¥₿℃℉_+./:%°×−–=()\[\]#,@&-]*)*/g;
  const content = 'main, header, footer, menu-drawer, cart-drawer, cart-notification, .shopify-section';
  const technicalValueSelector = '.sm-ar-review-specs td, .sm-ar-review-specs dd, .comparison-table__table td, .comparison-card__metrics dd, .comparison-card__detail-list dd';
  const arabicScript = /\p{Script_Extensions=Arabic}/u;
  function isolateTechnicalValue(cell) {
    if (!cell || !cell.matches(technicalValueSelector)) return;
    const owned = cell.dataset.arTechnicalValue === 'isolated';
    if (!owned && cell.hasAttribute('dir')) return;
    const text = cell.textContent.trim();
    const eligible = text && !arabicScript.test(text) &&
      !cell.closest('[contenteditable], [data-ar-bidi="off"]') &&
      !cell.querySelector('input, textarea, select, button, [contenteditable], [data-ar-bidi="off"]');
    if (eligible) {
      cell.dir = 'ltr';
      cell.dataset.arTechnicalValue = 'isolated';
    } else if (owned) {
      cell.removeAttribute('dir');
      delete cell.dataset.arTechnicalValue;
    }
  }
  function isolateText(node) {
    const parent = node.parentElement;
    if (!parent || parent.closest(skip) || !parent.closest(content) || (!arabic.test(node.data) && !parent.closest('.product__title, .card__heading, .sm-ar-review-specs, .comparison-table__table, .product__sku, .price-item'))) return;
    if (parent.closest('.product__title h1') && node.data.includes('"') && !arabicScript.test(node.data)) {
      const isolated = document.createElement('bdi');
      isolated.dir = 'ltr';
      isolated.dataset.arBidi = 'isolated';
      isolated.textContent = node.data;
      node.replaceWith(isolated);
      return;
    }
    const matches = Array.from(node.data.matchAll(latin));
    if (!matches.length) return;
    const fragment = document.createDocumentFragment();
    let offset = 0;
    for (const match of matches) {
      // Sentence punctuation remains in its Arabic context; paired technical parentheses stay together.
      let value = match[0];
      let previous;
      do {
        previous = value;
        value = value.replace(/[.,:;]+$/, '').trimEnd();
        for (const [open, close] of [['(', ')'], ['[', ']']]) {
          const count = (char) => value.split(char).length - 1;
          if (value.endsWith(close) && count(close) > count(open)) value = value.slice(0, -1).trimEnd();
          if (value.endsWith(open) && count(open) > count(close)) value = value.slice(0, -1).trimEnd();
        }
      } while (value !== previous);
      if (!value) continue;
      fragment.append(document.createTextNode(node.data.slice(offset, match.index)));
      const isolated = document.createElement('bdi');
      isolated.dir = 'ltr';
      isolated.dataset.arBidi = 'isolated';
      isolated.textContent = value;
      fragment.append(isolated);
      offset = match.index + value.length;
    }
    fragment.append(document.createTextNode(node.data.slice(offset)));
    // Preserve the original anonymous grid/flex text item when adding inline isolation.
    // A neutral custom element avoids matching existing summary > span icon rules.
    if (/^(?:inline-)?(?:grid|flex)$/.test(getComputedStyle(parent).display)) {
      const flow = document.createElement('ar-text-flow');
      flow.append(fragment);
      node.replaceWith(flow);
    } else {
      node.replaceWith(fragment);
    }
  }
  function enhance(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      isolateTechnicalValue(root.parentElement?.closest(technicalValueSelector));
      isolateText(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest('script, style, noscript, template, svg, math, [contenteditable]')) return;
    const elements = (selector) => [ ...(root.matches(selector) ? [root] : []), ...root.querySelectorAll(selector) ];
    isolateTechnicalValue(root.closest(technicalValueSelector));
    elements(technicalValueSelector).forEach(isolateTechnicalValue);
    elements('input:not([dir]), textarea:not([dir])').forEach((input) => {
      if (input.matches('[type="email"], [type="url"], [type="tel"], [type="number"]')) input.dir = 'ltr';
      else if (input.matches('textarea, [type="text"], [type="search"], input:not([type])')) input.dir = 'auto';
    });
    elements('.comparison-table__scroller, .sm-ar-review-specs__table').forEach((region) => {
      if (!region.hasAttribute('tabindex')) region.tabIndex = 0;
    });
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(isolateText);
  }
  function syncPurchaseAvailability() {
    document.querySelectorAll('product-info').forEach((info) => {
      const add = info.querySelector('button[id^="ProductSubmitButton-"]');
      const buy = info.querySelector('button[id^="StarminerBuyNow-"]');
      if (add && buy && buy.disabled !== add.disabled) buy.disabled = add.disabled;
    });
  }
  function updateViewportWidth() {
    document.documentElement.style.setProperty('--ar-viewport-width', document.documentElement.clientWidth + 'px');
  }
  function start() {
    updateViewportWidth();
    window.addEventListener('resize', updateViewportWidth, { passive: true });
    enhance(document.body);
    syncPurchaseAvailability();
    const observer = new MutationObserver((records) => {
      observer.disconnect();
      records.forEach((record) => {
        if (record.type === 'characterData') enhance(record.target);
        else if (record.type === 'childList') record.addedNodes.forEach(enhance);
      });
      syncPurchaseAvailability();
      observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
